import _pickBy from 'lodash/pickBy';

export const articleFilterSanitizer = (filters, for_axios = false) => {
  const {
    name,
    category,
    brand,
    status,
    page,
    per_page,
    types,
    supplier
  } = filters;
  const types_matcher = for_axios
    ? 'q[article_types_code_in]'
    : 'q[article_types_code_in][]';
  const sanitizedFilters = {
    name_cont: name,
    category_name_cont: category,
    brand_name_cont: brand,
    [types_matcher]: types,
    suppliers_name_cont: supplier,
    page: page,
    per_page
  };
  if (status === 'activos') {
    sanitizedFilters.active_eq = true;
  }

  if (status === 'inactivos') {
    sanitizedFilters.active_eq = false;
  }
  return _pickBy(sanitizedFilters, filter => !!filter || filter === false);
};

export const articleFilterSanitizerNode = filters => {
  const {
    name,
    category,
    brand,
    page,
    perPage,
    supplierId,
    active,
    isCommercialSale,
    types,
    useMegaQuota,
    isGasApplianceSale,
    isGeneralWarrantySale
  } = filters;

  const sanitizedFilters = {
    name,
    category,
    brand,
    supplierId,
    page,
    perPage,
    isCommercialSale,
    types,
    useMegaQuota,
    isGasApplianceSale,
    isGeneralWarrantySale
  };

  if (active !== 'todos') {
    sanitizedFilters.active = active;
  }

  return _pickBy(sanitizedFilters, filter => !!filter || filter === false);
};

export const articleSaveSanitizer = values => {
  const {
    name,
    categoryId,
    iva,
    description,
    conceptId,
    active,
    brandId,
    suppliers,
    articleTypes,
    maxItems,
    gracePeriod
  } = values;

  const sanitizedFilters = {
    name,
    categoryId: Number(categoryId),
    iva: Number(iva) || 0,
    description,
    conceptId: Number(conceptId),
    active,
    brandId: Number(brandId),
    gracePeriod,
    supplierIds: suppliers.map(s => Number(s.value)),
    articleTypesIds: articleTypes.map(at => Number(at.value))
  };

  const params = _pickBy(
    sanitizedFilters,
    filter => !!filter || filter === false
  );

  return {
    ...params,
    maxItems: maxItems && Number(maxItems) > 0 ? Number(maxItems) : null,
    iva: params.iva || 0
  };
};
